import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AppointmentBooking } from "../components";

const Appointment = () => {


  return (
        <AppointmentBooking />
  );
};

export default Appointment;